import { datadogRum } from '@datadog/browser-rum';
import { createListenerMiddleware } from '@reduxjs/toolkit';

import { alertsSlice } from './alertsSlice';
import { isSnackBarAlert } from './types';

import type { RootState } from 'store';

export const alertsListener = createListenerMiddleware<RootState>();

const extractAlertMessage = (message: unknown): string => {
  if (typeof message === 'string') return message;
  if (typeof message === 'object' && message !== null && 'message' in message) {
    return String((message as { message: unknown }).message);
  }
  return String(message);
};

alertsListener.startListening({
  actionCreator: alertsSlice.actions.addAppMessage,
  effect: ({ payload }) => {
    datadogRum.addAction('alert_displayed', {
      alertType: payload.type,
      alertContext: payload.context,
      alertSeverity: isSnackBarAlert(payload) ? payload.severity : undefined,
      alertMessage: extractAlertMessage(payload.message),
    });
  },
});
